import {InputContextValue} from 'components/common/CartItemBuilder/providers/InputProvider/types'
import {useCallback} from 'react'
import {useUserInputStepManager} from './useUserInputStepManager'

export const useOptionManager = (cartItemInputContextValue: InputContextValue) => {
  const getSavedData = useCallback(() => {
    return cartItemInputContextValue.input.optionId
  }, [cartItemInputContextValue])

  const setSavedData = useCallback(
    (optionId: string) => {
      return cartItemInputContextValue.mutators.setOptionId(optionId)
    },
    [cartItemInputContextValue]
  )

  const isDataTouched = useCallback((optionId: string) => {
    return Boolean(optionId)
  }, [])

  const isDataValid = useCallback((optionId: string) => {
    return Boolean(optionId)
  }, [])

  return useUserInputStepManager<string>({
    getSavedData,
    setSavedData,
    isDataTouched,
    isDataValid,
    hint: 'Please select a tour option',
  })
}
